<template>
  <div class="add-company-main" v-show="show">
    <transition name="opacity">
      <div class="cover" v-show="show"></div>
    </transition>
    <transition name="alert">
      <div class="box" v-show="show" @click="hiddenList">
        <div class="add-title">添加屏蔽公司</div>
        <div class="add-input" @click.stop>
          <input type="text" placeholder="请输入屏蔽公司名称" v-model="searchValue" @input="searchCompany">
          <div class="add-list" v-show="companies.length">
            <div
              class="add-item overflow"
              v-for="(item, index) in companies"
              :key="index"
              @click="selectCompany(item)" v-html="item.nick_name_highlight || item.highlight" />
          </div>
        </div>
        <div class="add-btn">
          <button @click="$emit('close')">取消</button>
          <button :class="[isActive ? 'active' : 'disabled']" @click="add">确定</button>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import api from '@/api';
export default {
  name: 'City',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      run: null,
      searchValue: '',
      companies: [],
      data: {}
    };
  },
  computed: {
    isActive() {
      return !!this.data.name;
    }
  },
  methods: {
    async add() {
      if (!this.isActive) return false;
      let res = await api.company.addBlockingCompanies(this.data.token);
      if (res.code === 1000) {
        this.$emit('update');
        this.$message.success('添加成功');
        this.searchValue = '';
        this.data = {};
      } else {
        console.log(res.message)
        this.$message.error(res.message);
      }
    },
    hiddenList() {
      if (this.companies.length) {
        this.searchValue = '';
        this.companies = [];
      }
    },
    selectCompany(data) {
      this.companies = [];
      this.data = data;
      this.searchValue = data.nick_name || data.name;
    },
    searchCompany() {
      clearTimeout(this.run);
      this.run = setTimeout(async () => {
        let res = await api.company.blockingCompanyAutoCompletions({ keyword: this.searchValue });
        console.log(res);
        this.companies = res.data;
      }, 300);
    }
  },
}
</script>
<style lang="scss" scoped>
.add-company-main {
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
  .cover {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, .5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 11;
  }
  .box {
    width: 446px;
    height: 310px;
    background: #fff;
    border-radius: 4px;
    position: fixed;
    left: 0;
    bottom: 0;
    top: 0;
    right: 0;
    margin: auto;
    z-index: 12;
    padding: 32px;
    .add-title {
      font-size: 18px;
      color: rgba(64, 64, 64, 1);
    }
    .add-input {
      width: 100%;
      height: 42px;
      border: 1px solid rgba(236, 236, 236, 1);
      margin-top: 24px;
      position: relative;
      input {
        width: 100%;
        height: 100%;
        padding: 0 16px;
      }
      .add-list {
        width: 100%;
        height: 160px;
        border: 1px solid rgba(236, 236, 236, 1);
        position: absolute;
        bottom: -6px;
        margin-bottom: -160px;
        background: #fff;
        z-index: 2;
        overflow-y: auto;
        padding-bottom: 24px;
        .add-item {
          margin-top: 20px;
          padding: 0 16px;
          cursor: pointer;
          ::v-deep .es-highlighter {
            color: #FF4F4C;
          }
        }
      }
    }
    .add-btn {
      position: absolute;
      bottom: 32px;
      right: 32px;
      button {
        width: 84px;
        height: 36px;
        border: 1px solid rgba(217, 217, 217, 1);
        margin-left: 16px;
        background: transparent;
        font-size: 14px;
        color: rgba(96, 96, 96, 1);
        border-radius: 2px;
        &.active {
          border-color: rgba(255, 79, 76, 1);
          background: rgba(255, 79, 76, 1);
          color: #fff;
          &:hover {
            border-color: rgba(255, 79, 76, .8);
            background: rgba(255, 79, 76, .8);
          }
        }
        &.disabled {
          background: rgba(207, 207, 207, 1);
          border-color: rgba(207, 207, 207, 1);
          color: #fff;
        }
      }
    }
  }
}
</style>